import { api } from "@/lib/api";

export const http = api;
export { errMsg } from "@/lib/api";

export const newId = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const getSessionId = () => {
  let id = localStorage.getItem("lm_adv_session");
  if (!id) {
    id = newId();
    localStorage.setItem("lm_adv_session", id);
  }
  return id;
};

import { metaAdvisorStart } from "@/lib/meta";

export const trackOpen = (entry, ad_source = "") => {
  metaAdvisorStart(entry);
  return api.post("/advisor/open", { session_id: getSessionId(), entry, ad_source }).catch(() => {});
};

export const fetchEstimate = (slugs) =>
  slugs.length ? api.post("/advisor/estimate", { slugs }).then((r) => r.data.estimate).catch(() => 0) : Promise.resolve(0);

export const track = (stage, extra = {}) =>
  api.post("/advisor/events", { session_id: getSessionId(), stage, ...extra }).catch(() => {});
